import { render } from "./SearchHeader.vue?vue&type=template&id=2d290b90&scoped=true&ts=true"
import script from "./SearchHeader.vue?vue&type=script&lang=ts"
export * from "./SearchHeader.vue?vue&type=script&lang=ts"

import "./SearchHeader.vue?vue&type=style&index=0&id=2d290b90&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d290b90"]])

export default __exports__